export enum GTM_EVENT_TYPE {
  SESSION_LOGIN = 'login',
  LOGIN_WITH_CREDENTIALS = 'login_with_credentials',
  LOGOUT = 'logout',
  FIRST_TIME_DEPOSIT = 'first_time_deposit',
  DEPOSIT = 'deposit',
  STARTED_REGISTRATION = 'started_registration',
  COMPLETED_REGISTRATION = 'completed_registration',
  LOADING_SCREEN_DURATION = 'loading_screen_duration',
}

export enum GTM_VARIABLE {
  USER_SCOPED_USER_ID = 'user_id',
  EVENT_SCOPED_USER_ID = 'userId',
  FINGERPRINT = 'fingerprint',
  TRANSACTION_ID = 'transaction_id',
  TIMESTAMP = 'timestamp',
  EVENT_VALUE = 'eventValue',
}
